import { defineNuxtPlugin, useRouter } from 'nuxt/app';
import { useAuthChannel } from '~/composables/useAuthChannel';
import { useExamSession } from '~/composables/useExamSession';
import { useUserService } from '~/composables/service/useUserService';
import { removeCookie } from '@@/package/utils/CookieUtil';
import { CookieKeyType } from '@@/package/mapper/common/model/CookieKeyType';
import { RouteName } from '@@/package/enum/RouteName';

// token-invalidation (AUTH-LOGOUT-05): when another tab logs out (or is forced out by a 401),
// mirror that here — clear local user state + cookies and return to root.
// UX only; the server has already revoked the token.
export default defineNuxtPlugin(() => {
    const { subscribeLogout } = useAuthChannel();

    subscribeLogout(() => {
        // #2260 (D9): on the taking screen the cascade below is blocked by the route-leave guard
        // and would blank the uuid; show the session-expired popup instead.
        const examSession = useExamSession();
        if (examSession.isActive()) {
            examSession.expire();
            return;
        }
        removeCookie(CookieKeyType.ACCESS_TOKEN);
        removeCookie(CookieKeyType.OPEN_CREDIT_BANNER);
        useUserService().userLogOut();
        useRouter().replace({ name: RouteName.Root });
    });
});
